import { Attributes, Misc, NeoModel, Rules, Validation, ValueObject } from "@singularsystems/neo-core";
import { TextConstants } from "../../../Common/TextConstants";

@NeoModel
export default class DividendWithholdingTaxReportCriteria extends ValueObject {
    @Rules.Required()
    public staticServiceProviderFileGroupingId: number = 0;

    public serviceProviderGroupingName: string = "";

    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Rules.Required()
    public startDate: Date = new Date();

    @Attributes.Date(Misc.TimeZoneFormat.None)
    @Rules.Required()
    public endDate: Date = new Date();

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);

        rules.failWhen(d => (d.endDate < d.startDate), TextConstants.Validation.StartDateBeforeEndDate);
    }
}